import type { IStaffDepartment } from '../types/IStaffDepartment'

/** Ширина карточки и gap ряда детей (Bitrix-like layout) */
export const ORG_CARD_WIDTH = 380
export const ORG_CHILDREN_GAP = 24
/** Расстояние от низа карточки родителя до верха карточки ребёнка (линия по центру) */
export const ORG_LEVEL_VERTICAL_GAP = 160
/** Минимальная высота карточки — siblings в одном ряду выравниваются по высоте */
export const ORG_CARD_MIN_HEIGHT = 200
/** Outline выбранной карточки (не входит в getBoundingClientRect) */
export const ORG_CARD_SELECTED_OUTLINE_PX = 8

/** Ширина колонки узла с учётом раскрытых детей (режим «вся иерархия») */
export function measureOrgSubtreeSpanWidth(
  node: IStaffDepartment,
  expandedIds: readonly string[],
): number {
  const id = String(node.id)
  const children = (node.children || []).filter(c => c && c.id !== 'empty')
  if (!expandedIds.includes(id) || !children.length)
    return ORG_CARD_WIDTH

  const rowWidth = children.reduce((sum, child, idx) => {
    const w = measureOrgSubtreeSpanWidth(child, expandedIds)
    return sum + w + (idx > 0 ? ORG_CHILDREN_GAP : 0)
  }, 0)

  return Math.max(ORG_CARD_WIDTH, rowWidth)
}
